var getBlockIndex=function(content,blockKey){return content.blocks.findIndex((function(block){return block.key===blockKey}))};export{getBlockIndex};
//# sourceMappingURL=draftUtils.js.map
